<script>
import countTo from 'vue-count-to'
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import {
  widgetData,
  revenueRadialChart,
  historyChart,
  userBalanceData,
  pieChart,
  geoChart
} from './data'
import Axios, * as axios from "axios";
import { authComputed } from '@state/helpers';
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';

const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';
const SITES_API_URL = process.env.VUE_APP_API_URL + 'sites/';
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { countTo, DatePicker, Layout, Multiselect },
  data() {
    return {
      userId: 0,
      seeAs: '',
      disabledBefore: new Date(2021, 2, 1),
      sitesGroupedByPublisher: [],
      publisherList: [],
      sitesGroup: true,
      hideZeros: false,
      loading: true,
      reportDownloading: false,
      siteMetricsDownloading: false,
      requests: 0,
      impressions: 0,
      cpm: 0,
      revenue: 0,
      selectedSites: [],
      finalSelectedSites: [],
      selectedPublishers: [],
      selectedOneSite: '',
      // selectedAdunit: 0,
      selectedDate: '',
      sites: [],
      groupBy: 0,
      widgetData: widgetData,
      historyChartApiData: [],
      browserChartApiData: null,
      deviceChartApiData: null,
      operationSystemChartApiData: null,
      geoChartApiData: null,
      sitesData: [],
      sitesDataByDate: [],
     // adunitsData: [],
     // adunitsDataByDate: [],
      revenueRadialChart: revenueRadialChart,
      userBalanceData: userBalanceData,
      title: 'Dashboard',
      showSiteMetrics: false,
      currency: '€',
      browserColors: ['#82d4c9','#f0b8b8', '#e67f83', '#de425b','#bce3dd' ],
      deviceTypeColors: ['#fcaf7c','#ffd792','#fffdb7','#e0f5a7','#bcee9d', '#91e799'],
      operationSystemColors: ['#ffc4e7', '#dddbff','#c0f1ff','#c8ffff', '#97e0e3', '#62c1c9', '#0fa3b1'],
      items: [
        {
          text: 'Unblockia',
          href: '/',
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
      shortcuts: [
        // { text: 'today', onClick: () => new Date() },
        {
          text: 'Yesterday',
          onClick: () => {
            this.selectedDate = [new Date(this.yesterday), new Date(this.yesterday)];
            return 'Yesterday';
          },
        },
        {
          text: 'Last 7 days',
          onClick: () => {
            this.selectedDate = [new Date(this.sevenDaysAgo), new Date(this.yesterday)];
            return this.yesterday;
          },
        },
        {
          text: 'Last 30 days',
          onClick: () => {
            this.selectedDate = [new Date(this.thirtyDaysAgo), new Date(this.yesterday)];
            return this.thirtyDaysAgo;
          },
        },
      ],
      perPage: 25,
      currentPage: 1,
      sortBy: 'domain',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      showCalculator: false,
      usdInput: 0,
      usdDisplay: '',
      rateInput: 0,
      rateDisplay: '',
      checkCurrency: '',
      currencyAlert: '',
      showEmbeddedContainer: false,
      embedLoading: false
      }
  },
  computed: {
    isOcm: function() {
      return (this.selectedSites.length && this.selectedSites.map(x => x.publisher).filter(x => x === "OCM").length === this.selectedSites.length)
              || JSON.parse(localStorage["auth.currentUser"]).name === "OCM"
    },
    isOcmUser: function() {
      return JSON.parse(localStorage["auth.currentUser"]).name === "OCM"
    },
    isVocentoUser: function() {
      return JSON.parse(localStorage["auth.currentUser"]).name === "Vocento"
    },
    siteDataByDateFields: function() {
      let fields = [
        { key: 'no.', stickyColumn: true},
        { key: 'date'},
        { key: 'domain', sortable: true},
        { key: 'pageViews', sortable: true},
        { key: 'adblockRate', sortable: true},
        { key: 'impressions', sortable: true},
        { key: 'viewability', sortable: true},
        { key: 'clicks', sortable: true },
        { key: 'cpm', label:"CPM", sortable: true},
        { key: 'grossRevenue', label:"Gross Rev.", sortable: true},
        { key: 'netRevenue', label:"Net Rev.", sortable: true},
        { key: 'platform'},
      ];

      if (this.isUser || this.mode === 'user') {
        fields = fields.filter( x => x.key !== 'viewability' )
      }

      if (!this.showSiteMetrics) {
        fields = fields.filter( x => x.key !== 'clicks' && x.key !== 'platform')

      }

      if (this.mode == 'eyeo') {
          fields = fields.filter( x => x.key !== 'clicks')
        }

      return fields;
    },
    siteDataFields: function() {
      let fields = [
        { key: 'no.', stickyColumn: true},
        { key: 'domain', sortable: true},
        { key: 'pageViews', sortable: true},
        { key: 'adblockRate', sortable: true, title: "Adblock Rate"},
        { key: 'impressions', sortable: true},
        { key: 'viewability', sortable: true},
        { key: 'clicks', sortable: true },
        { key: 'cpm', label:"CPM", sortable: true},
        { key: 'grossRevenue', label:"Gross Rev.", sortable: true},
        { key: 'netRevenue', label:"Net Rev.", sortable: true},
        { key: 'platform'}
      ];

      if (this.isUser || this.mode === 'user') {
        fields = fields.filter( x => x.key !== 'viewability' )
      }

      if (!this.showSiteMetrics) {
        fields = fields.filter( x => x.key !== 'clicks' && x.key !== 'platform' )

      }

      if (this.mode === 'eyeo') {
          fields = fields.filter( x => x.key !== 'clicks')
        }

      return fields;
    },
    siteDataItems: function() {
      if (this.hideZeros) {
        return this.sitesData.filter(x => x.requests)
      }

      return this.sitesData
    },
    mode: function() {
      if (this.isAdmin) {
        return this.seeAs || 'admin'
      }

      return JSON.parse(localStorage["auth.currentUser"]).role.name
    },
    today: function() {
      return new Date()
    },
    yesterday: function() {
      const d = new Date();
      return d.setDate(d.getDate() - 1)
    },
    sevenDaysAgo: function() {
      const d = new Date();
      return d.setDate(d.getDate() - 8)
    },
    thirtyDaysAgo: function() {
      const d = new Date();
      return d.setDate(d.getDate() - 31)
    },
    historyChart: function() {
      if (this.historyChartApiData && this.historyChartApiData.length) {
        return historyChart(this, this.historyChartApiData, this.currency);
      } else {
        return {
          chartOptions: {},
          series: []
        }
      }
    },
    browserChart: function() {
      if (this.browserChartApiData) {
        return pieChart(this.browserChartApiData, this.browserColors);
      } else {
        return {
          chartOptions: {},
          series: []
        }
      }
    },
    deviceTypeChart: function() {
      if (this.deviceChartApiData) {
        return pieChart(this.deviceChartApiData, this.deviceTypeColors);
      } else {
        return {
          chartOptions: {},
          series: []
        }
      }
    },
    operationSystemChart: function() {
      if (this.operationSystemChartApiData) {
        return pieChart(this.operationSystemChartApiData, this.operationSystemColors);
      } else {
        return {
          chartOptions: {},
          series: []
        }
      }
    },
    geoChart: function() {
      if (this.geoChartApiData) {
        if (!this.geoChartApiData.data.length) {
          return false
        }
        return geoChart(this.geoChartApiData);
      } else {
        return {
          chartOptions: {},
          series: []
        }
      }
    },

    ...authComputed,
    isAdmin: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
    },
    isFinance: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "finance"
    },
    isEyeo: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "eyeo"
    },
    isUser: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "user"
    },
    isMediaBuyer: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "media buyer"
    },
    isAccountManager: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "account manager"
    },
    isTrafficker: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "trafficker"
    },
    fromTo: function () {
      return `from=${this.prettyDate(this.selectedDate[0])}&to=${this.prettyDate(this.selectedDate[1])}`
    },
    rows(){
      return this.sitesGroup ? this.siteDataItems.length : this.sitesDataByDate.length
    },
    siteDataItemsTable: function() {
      if (this.hideZeros) {
        return this.siteDataTable.filter(x => x.requests)
      }

      return this.siteDataTable
    },
    siteDataTable : function(){
      return this.siteDataItems.map((item,index) => ({
            ...item,
            viewability:  item.viewRate ? (parseFloat(item.viewRate) * 100).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '%' : '-',
            impressions: item.requests

    }))
    },
    siteDataByDateTable : function(){
      return this.sitesDataByDate.map((item,index) => ({
          ...item,
          viewability:  item.viewRate ? (parseFloat(item.viewRate) * 100).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '%' : '-',
          impressions: item.requests ? item.requests.toLocaleString('de-DE') : 0
    }))
    },
    euroInput: function(){
      return (this.usdInput * this.rateInput).toLocaleString('de-DE')
    },
    currencyAlertMessage: function () {
      if(!this.currencyAlert) {
        return ''
      } else if(this.currencyAlert.changeCurrencyAt) {
        return `Publisher ${this.checkCurrency.toUpperCase()}'s sites are monetized in ${this.currencyAlert.currency === 'eur' ? 'USD' : 'EUR'} after ${this.currencyAlert.changeCurrencyAt}`
      } else {
        return  `Publisher ${this.checkCurrency.toUpperCase()}'s sites are monetized in ${this.currencyAlert.currency.toUpperCase()}`;
      }
    },
    filteredSiteList: function() {
      if (!this.selectedPublishers.length) {
        return this.sitesGroupedByPublisher
      }
      return this.sitesGroupedByPublisher.filter( group => {
        return this.selectedPublishers.map( x => x.name).includes(group.publisher);
      })
    }
  },
  watch: {
  },
  async mounted() {
    if (this.isOcmUser) {
      this.$router.push('/ocm')
    }

    if (this.isVocentoUser) {
      this.$router.push('/vocento')
    }

    this.seeAs = JSON.parse(localStorage["auth.currentUser"]).role.name;
    this.userId = JSON.parse(localStorage["auth.currentUser"]).id;
    await this.fetchSiteList();

    if (!this.isUser){
      this.publisherList = this.sitesGroupedByPublisher.filter( x => x.sites.length > 0).map( (y, key) => {return {id: key, name: y.publisher}});
    }
    const fetchSitesResponse = await axios(DASHBOARD_API_URL + `sites?${this.fromTo}`);
    this.sites = [...this.sites, ...fetchSitesResponse.data.sites].sort((a, b) => a.domain.toLowerCase().localeCompare(b.domain.toLowerCase()));
    this.selectedDate = [new Date(this.sevenDaysAgo), new Date(this.yesterday)];
    await this.init();
    this.loading = false;

    if (this.isEyeo) {
      this.hideZeros = true;
    }

  },
  methods: {
    async handleSeeAsChange() {
      await this.init();
    },
    async toggleEmbeddedContainer(){
      if(this.$refs.embeddingContainer.hasChildNodes()){
        this.$refs.embeddingContainer.children[0].remove();
      }
      let options;
      this.embedLoading = true;
      if(this.dashboard === undefined){
        options = await this.embedDashboard();
      }
      this.embedLoading = false;
      this.showEmbeddedContainer = !this.showEmbeddedContainer;

      if(!options){
        return;
      }

      const dashboard = embedDashboard(options);
      if(dashboard === undefined){
        this.showEmbeddedContainer = !this.showEmbeddedContainer;
      }
    },
    async embedDashboard(){
      let dashboardId;
      let sheetId;
      let sheetTabsDisabled;
      let parameters = {
            startDate: this.selectedDate[0],
            endDate: this.selectedDate[1]
      };

      if(this.seeAs === 'eyeo'){
        if(this.selectedSites.length > 0){
          dashboardId = 'bb5f6730-d796-419a-8098-cee57994f6ea';
          sheetId = 'bb5f6730-d796-419a-8098-cee57994f6ea_5844bba4-46d5-4a48-acb7-bce904088ba2';
          parameters.domainList = this.selectedSites.map(x => x.domain);
          sheetTabsDisabled = false;
        } else {
          dashboardId='297fe88a-628a-4bbe-9e56-d7aca0d43aae';
          sheetId = 'bb5f6730-d796-419a-8098-cee57994f6ea_8e8f3893-6f98-4c87-8755-8477a49f69e5';
          sheetTabsDisabled = false;
        }
      } else if(this.seeAs === 'admin'){
          if(this.selectedSites.length > 0){
            dashboardId = '1ec48a74-ccae-4108-8f24-5cb82c43c960';
            parameters.domainList = this.selectedSites.map(x => x.domain);
          } else {
            dashboardId = '65b8bfbc-382b-418d-b874-1a9bfb86edc0';
          }
      } else if(this.seeAs === 'media buyer'){
          if(this.selectedSites.length > 0){
            dashboardId = '238c2a19-3a50-45fc-b6be-b963051f6556';
            parameters.domainList = this.selectedSites.map(x => x.domain);
            sheetTabsDisabled = false;
          } else {
            this.$swal.fire({
              type: 'error',
              title: 'No site selected',
              text: 'You must select a site first!',
            });
            return undefined;
          }

      } else {
        this.$swal.fire({
          type: 'error',
          title: 'Not implemented yet',
          text: 'We are working on the new dashboard',
        });
        return undefined;
      }

      const dashboardResponse = await Axios.get(`${process.env.VUE_APP_API_URL}aws/embeddedURL/${dashboardId}`);
      const eyeo_dashboard_url = dashboardResponse.data.EmbedUrl;

      var options = {
          url: eyeo_dashboard_url,
          container: this.$refs.embeddingContainer,
          parameters: parameters,
          scrolling: "yes",
          height: '800px',
          width: '100%',
          iframeResizeOnSheetChange: true, // use this option in combination with height: AutoFit, to allow iframe height to resize dynamically, based on sheet height, on changing sheets.
          locale: "en-US",
          footerPaddingEnabled: true,
          sheetId: sheetId, // use this option to specify initial sheet id to load for the embedded dashboard
          sheetTabsDisabled: sheetTabsDisabled, // use this option to enable or disable sheet tab controls in dashboard embedding
          printEnabled: true, // use this option to enable or disable print option for dashboard embedding
          undoRedoDisabled: true, // set this option to true to disable undo and redo buttons for dashboard embedding
          resetDisabled: true, // set this option to true to disable reset button for dashboard embedding
      };

      return options;
    },
    base64ToArrayBuffer: function (base64) {
      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    },
    async fetchDownloadableReport(format) {
      const response = await axios(DASHBOARD_API_URL + `stats/download/${format}?${this.fromTo}&sites=${this.selectedSites.map(x => x.id).join(",")}&mode=${this.mode}`);
      let blob;

      if (['excel', 'excel-eyeo', 'excel-eyeo-incontent'].includes(format)) {
        blob = new Blob([this.base64ToArrayBuffer(response.data)]);
      } else {
        blob = new Blob([response.data], { type: format === 'excel' ? 'application/vnd.ms-excel' : ''});
      }
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `report-${Date.now()}.${format === 'csv' ? 'csv' : 'xlsx'}`;
      link.click();
      this.reportDownloading = false;
    },


    async fetchDownloadableSiteMetrics(format) {
      const response = await axios(DASHBOARD_API_URL + `stats/site-metrics-download/excel?${this.fromTo}&site=${this.selectedOneSite}&mode=${this.mode}`);
      let blob;

        blob = new Blob([this.base64ToArrayBuffer(response.data)]);

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `report-${Date.now()}.${format === 'xlsx'}`;
      link.click();
      this.siteMetricsDownloading = false;
    },
    async fetchSiteList() {
      const response = await axios(SITES_API_URL + `all/grouped-by-publisher`);
      this.sitesGroupedByPublisher = response.data;
    },
    async fetchStats() {

      this.checkCurrency = '';
      this.currencyAlert = '';

      /* check currency */
      if(['admin', 'media buyer', 'account manager', 'trafficker'].includes(this.mode)) {
        this.selectedSites.forEach(site => {
          if(site.publisher == this.selectedSites[0].publisher){
            this.checkCurrency = this.selectedSites[0].publisher;
          } else {
            this.checkCurrency = '';
          }
        })
      }

      const response = await axios(DASHBOARD_API_URL + `stats?${this.fromTo}&sites=${this.finalSelectedSites.map(x => x.id).join(",")}&mode=${this.mode}&checkCurrency=${this.checkCurrency}`);
      if (response.data.currency === 'eur') {
        this.currency = '€';
      } else if (response.data.currency === 'usd') {
        this.currency = '$';
      } else if (!response.data.currency) {
        this.currency = '';
      }
      this.changeCurrencyAt = response.data.changeCurrencyAt;

      if (response.data.currencyAlert && Object.keys(response.data.currencyAlert).length !== 0) {
        this.currencyAlert = response.data.currencyAlert;
      }

      this.widgetData = widgetData(response.data, this.mode, this.currency, this.isOcm);

    },
    async fetchHistory() {
      const fetchHistoryResponse = await axios(DASHBOARD_API_URL + `stats/history?${this.fromTo}&sites=${this.finalSelectedSites.map(x => x.id).join(",")}&mode=${this.mode}`);
      const { days } = fetchHistoryResponse.data;
      this.historyChartApiData = days;
    },
    async fetchSitesData() {
      const fetchSitesStatsResponse = await axios(DASHBOARD_API_URL + `stats/sites?${this.fromTo}&sites=${this.finalSelectedSites.map(x => x.id).join(",")}&mode=${this.mode}`);
      const { sitesData, sitesDataByDate } = fetchSitesStatsResponse.data;
      this.sitesData = sitesData;
      this.sitesDataByDate = sitesDataByDate
    },
    prettyDate: function (date) {
      // `this` points to the vm instance
      const d = new Date(date);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return yyyy + '-' + mm + '-' + dd;
    },
    async init() {
      this.loading = true;
      this.showEmbeddedContainer=false;
      /* site metrics */
      if (this.selectedSites.length == 1) {
        this.selectedOneSite = this.selectedSites[0];
      } else {
        this.selectedOneSite = '';
      }

      /* get finalSelectedSites */
      if (this.selectedSites.length > 0) {
        this.finalSelectedSites = this.selectedSites;
      }
      if (this.selectedPublishers.length > 0 && this.selectedSites.length === 0) {
        const publisherNames = this.selectedPublishers.map( publisher => publisher.name);
        let siteList = [];
        this.sitesGroupedByPublisher.forEach( x => {
          if (publisherNames.includes(x.publisher)) {
            siteList = [...siteList, ...x.sites];
          }
        });
        this.finalSelectedSites = siteList;
      }

      await this.fetchStats();
      await this.fetchHistory();
      await this.fetchSitesData();

      if (['admin', 'eyeo', 'media buyer', 'account manager', 'trafficker', 'finance'].includes(this.mode) && this.selectedSites.length == 1){
        this.showSiteMetrics = true;

        const geoChartApiDataResponse = await axios(DASHBOARD_API_URL + `stats/site-metrics?${this.fromTo}&sites=${this.selectedSites.map(x => x.id).join(",")}&mode=${this.mode}&type=country`);
        this.geoChartApiData = geoChartApiDataResponse.data;

        const browserChartApiDataResponse = await axios(DASHBOARD_API_URL + `stats/site-metrics?${this.fromTo}&sites=${this.selectedSites.map(x => x.id).join(",")}&mode=${this.mode}&type=browser`);
        this.browserChartApiData = browserChartApiDataResponse.data;

        const deviceChartApiDataResponse = await axios(DASHBOARD_API_URL + `stats/site-metrics?${this.fromTo}&sites=${this.selectedSites.map(x => x.id).join(",")}&mode=${this.mode}&type=device`);
        this.deviceChartApiData = deviceChartApiDataResponse.data;

        const operationSystemChartApiDataResponse = await axios(DASHBOARD_API_URL + `stats/site-metrics?${this.fromTo}&sites=${this.selectedSites.map(x => x.id).join(",")}&mode=${this.mode}&type=operationSystem`);
        this.operationSystemChartApiData = operationSystemChartApiDataResponse.data;


      } else {
        this.showSiteMetrics = false;
      }
      this.loading = false;
    },
    async downloadReport(format) {
      this.reportDownloading = true;
      await this.fetchDownloadableReport(format)
    },
    async downloadSiteMetrics(format) {
      this.siteMetricsDownloading = true;
      await this.fetchDownloadableSiteMetrics(format)
    },

    handleUsdInput() {
      this.usdInput = this.usdInput;
    },

    handleRateInput() {
      this.rateInput = this.rateInput;
    },

    currencyFormat(value) {
      if(value.slice(-1)==='.' && !value.slice(0,-1).includes('.')) {
        if(!isNaN(Number(value.slice(0,-1).trim().replace(/,/g, '')))) {
          this.usdInput = value;
          return this.usdInput
        }
      }
      if(isNaN(Number(value.trim().replace(/,/g, '')))) {
        return this.usdInput
      }
      this.usdInput = Number(value.trim().replace(/,/g, ''));
      return Number(this.usdInput).toLocaleString('de-DE')
    },
    rateFormat(value) {
      if(value.slice(-1)==='.' && !value.slice(0,-1).includes('.')) {
        if(!isNaN(Number(value.slice(0,-1).trim().replace(/,/g, '')))) {
          this.rateInput = value;
          return this.rateInput
        }
      }
      if(isNaN(Number(value.trim().replace(/,/g, '')))) {
        return this.rateInput
      }
      this.rateInput = Number(value.trim().replace(/,/g, ''));
      return Number(this.rateInput).toLocaleString('de-DE')
    },
  }
}
</script>

<template>
  <Layout>
      <div class="row home-page">
            <div class="col-12">
              <div class="page-title-box">
                <h4 class="page-title-left mt-4">Dashboard </h4>
                <div class="page-title-right mt-2">
                  <div v-if="isAdmin" class="mb-1 mode-selector">
                    <span class="text-muted mr-2 see-as-label">See As: </span>
                    <div class="radio radio-info form-check-inline mt-1">
                      <input id="inlineRadio1" v-model="seeAs" type="radio" value="admin" name="radioSeeAs" checked @change="handleSeeAsChange"/>
                      <label for="inlineRadio1">Admin</label>
                    </div>
                    <div class="radio radio-info form-check-inline mt-1">
                      <input id="inlineRadio1" v-model="seeAs" type="radio" value="finance" name="radioSeeAs" checked @change="handleSeeAsChange"/>
                      <label for="inlineRadio1">Finance</label>
                    </div>
                    <div class="radio form-check-inline">
                      <input id="inlineRadio2" v-model="seeAs" type="radio" value="user" name="radioSeeAs" @change="handleSeeAsChange" />
                      <label for="inlineRadio2">Publisher</label>
                    </div>
                    <div class="radio form-check-inline">
                      <input id="inlineRadio3" v-model="seeAs" type="radio" value="media buyer" name="radioSeeAs" @change="handleSeeAsChange" />
                      <label for="inlineRadio3">Media Buyer</label>
                    </div>
                    <div class="radio form-check-inline">
                      <input id="inlineRadio4" v-model="seeAs" type="radio" value="eyeo" name="radioSeeAs" @change="handleSeeAsChange" />
                      <label for="inlineRadio4">Eyeo</label>
                    </div>
                  </div>
                  <form class="form-inline mb-2">
                    <div class="form-group flex-form">
                      <div v-if="mode !== 'user'" class="input-group input-group-sm mr-2">
                        <multiselect
                                v-model="selectedPublishers"
                                :options="publisherList"
                                :multiple="true"
                                placeholder="Select publishers"
                                track-by="id"
                                label="name"
                                :close-on-select="false"
                                width="300"
                        >
                        </multiselect>
                      </div>
                      <div class="input-group input-group-sm mr-2">
                        <multiselect
                                v-model="selectedSites"
                                :options="filteredSiteList"
                                :multiple="true"
                                placeholder="Select sites"
                                track-by="id"
                                label="domain"
                                :close-on-select="false"
                                width="300"
                                group-values="sites"
                                group-label="publisher"
                                :group-select="true"
                        >
                        </multiselect>
                      </div>
                      <div class="input-group input-group-sm">
                        <date-picker
                              v-model="selectedDate"
                              :first-day-of-week="1"
                              class="border-white home-date-picker"
                              :not-after="yesterday"
                              range
                              append-to-body
                              lang="en"
                              :shortcuts="shortcuts"
                              confirm
                              :not-before="isEyeo ? disabledBefore : undefined"
                        >
                        </date-picker>
                      </div>
                      <a href="javascript: void(0);" class="btn btn-blue btn-sm ml-2" @click="init">
                        <i class="mdi mdi-autorenew"></i>
                      </a>
                      <b-dropdown v-if="!reportDownloading && currency" variant="primary" type="button" dropright class="ml-1 download-btn btn-primary">
                        <template slot="button-content">
                          Download
                          <i class="mdi mdi-download"></i>
                        </template>
                        <b-dropdown-item v-if="['admin', 'user', 'media buyer', 'account manager', 'trafficker', 'finance'].includes(mode)" @click="downloadReport('csv')">CSV</b-dropdown-item>
                        <b-dropdown-item v-if="['admin', 'user', 'media buyer', 'account manager', 'trafficker', 'finance'].includes(mode)" @click="downloadReport('excel')">EXCEL</b-dropdown-item>
                        <b-dropdown-item v-if="['admin', 'eyeo'].includes(mode)" @click="downloadReport('excel-eyeo')">{{mode === 'admin' ? 'EXCEL (Eyeo)' : 'EXCEL'}}</b-dropdown-item>
                        <!-- <b-dropdown-item v-if="['admin', 'eyeo'].includes(mode)" @click="downloadReport('excel-eyeo-incontent')">{{mode === 'admin'? 'EXCEL (Eyeo-Incontent)' : 'EXCEL (Incontent)'}}</b-dropdown-item> -->
                      </b-dropdown>
                      <button v-if="reportDownloading" type="button" disabled="disabled" class="btn ml-1 btn-primary disabled download-btn">
                        <span aria-hidden="true" class="spinner-border spinner-border-sm">
                        </span>&nbsp;&nbsp;Downloading...
                      </button>

                      <b-button v-if="mode === 'admin'" v-b-modal.modal-no-backdrop size="sm" variant="success" class="ml-1" @click="showCalculator = !showCalculator"><i class="mdi mdi-calculator"></i></b-button>
                      <b-card v-if="showCalculator && mode === 'admin'" class="calculator">
                        <b-card-title class="mb-4">Currency Convertor</b-card-title>

                        <div class="currency-unit">
                          <div>
                            <img src="@assets/images/usa.png" alt="">
                            <span class="text-dark">USD</span>
                          </div>
                          <div>
                            <b-form-input
                                v-model="usdDisplay"
                                class="form-control"
                                type="text"
                                :formatter="currencyFormat"
                                @input="handleUsdInput"
                            ></b-form-input>
                            <span class="text-dark">$</span>
                          </div>

                        </div>

                        <div class="rate-unit">
                          <span class="text-dark"><i class="mdi mdi-arrow-down mr-2"/></span>
                          <b-form-input
                              v-model="rateDisplay"
                              class="form-control"
                              :formatter="rateFormat"
                              type="text"
                              @input="handleRateInput">
                          </b-form-input>
                        </div>

                        <div class="currency-unit">
                          <div>
                            <img src="@assets/images/europe.png" alt="">
                            <span class="text-dark">EUR</span>
                          </div>
                          <div>
                            <b-form-input v-model="euroInput" class="form-control" type="text"></b-form-input>
                            <span class="text-dark">€</span>
                          </div>

                        </div>

                      </b-card>

                      <div
                          v-if="currencyAlert"
                          id="popover-currency"
                          v-b-popover.hover.bottom="currencyAlertMessage"
                          class="ml-1"
                      >
                            <i class="mdi mdi-alert-circle"></i>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </div>
      </div>
      <div v-if="!currency" class="d-flex justify-content-center">
        <p class="col-7 date-conflict">⏳ Please select a valid date range before or after <b>{{changeCurrencyAt}}</b>, the range you are searching for has a conflict with the currency exchange. </p>
      </div>
      <div v-else>
        <div v-if="loading" class="row justify-content-center" >
          <b-spinner label="Spinning" class="m-2"></b-spinner>
        </div>
        <div v-else>
          <div class="row">
            <div
                    v-for="widget in widgetData"
                    :id="'tooltip-top-' + widget.id"
                    :key="widget.id"
                    class="col-md-4 col-xl-3" variant="light"
            >
              <div class="widget-rounded-circle card-box ribbon-box border widget-card-unit">
                <div class="row ">
                  <div class="col-5">
                    <div
                            :class="`avatar-lg rounded-circle bg-soft-${widget.color} border-${widget.color} border`"
                    >
                      <i :class="`${ widget.icon } font-22 avatar-title text-${ widget.color}`"></i>
                    </div>
                  </div>
                  <div class="col-7">
                    <div class="text-right">
                      <h3 class="text-dark mt-1">
                      <span>
                        {{widget.value}}
                      </span>
                      </h3>
                      <p class="text-muted mb-1 text-truncate">{{ widget.text }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-tooltip v-for="widget in widgetData" :target="'tooltip-top-' + widget.id" placement="bottom"> {{ widget.tooltip }}</b-tooltip>
          </div>

          <div class="row">
            <div class="col-xl-12">
              <div class="card-box pb-1">
                <h4 class="header-title mb-3">Overview</h4>
                <div style="height: 375px;">
                  <apexchart
                          height="370"
                          type="line"
                          :options="historyChart.chartOptions"
                          :series="historyChart.series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>

          <div v-if="seeAs !== 'eyeo'" class="row">
            <div class="col-xl-12">
              <div class="card-box">

                <div class="d-flex justify-content-between mb-3" >
                  <h4 class="header-title">Site statistics</h4>
                  <div class="d-flex">
                    <div class="custom-control custom-checkbox mr-2">
                      <input id="customCheck2" v-model="hideZeros" type="checkbox" class="custom-control-input" />
                      <label
                              class="custom-control-label"
                              for="customCheck2"
                      >Hide 0's</label>
                    </div>
                    <div class="custom-control custom-checkbox ml-2">
                      <input id="customCheck1" v-model="sitesGroup" type="checkbox" class="custom-control-input" />
                      <label
                              class="custom-control-label"
                              for="customCheck1"
                      >Group by domain</label>
                    </div>
                  </div>
                </div>

                <div v-if="showSiteMetrics" class="d-flex justify-content-between align-items-center flex-wrap mb-3">
                  <div class="d-flex flex-wrap">
                    <span class=" static-domain font-weight-bold bg-light border mr-2 pl-md-2 pr-md-2 mb-2">{{selectedOneSite.domain}}</span>
                    <span v-if="siteDataTable[0].category" class=" category border pl-md-2 pr-md-2 mb-2"> <b>Category:</b> {{selectedOneSite ? siteDataTable[0].category : ''}}</span>
                  </div>

                  <!-- <b-dropdown variant="primary" v-if="mode === 'admin' && !siteMetricsDownloading" type="button" dropright class="mb-2 ml-1 download-btn btn-primary site-metrics-download">
                      <template slot="button-content">
                        Download
                        <i class="mdi mdi-download"></i>
                      </template>
                      <b-dropdown-item @click="downloadSiteMetrics('excel')">EXCEL (Eyeo)</b-dropdown-item>
                  </b-dropdown>
                  <button type="button" disabled="disabled" class="btn ml-1 btn-primary disabled download-btn" v-else>
                    <span aria-hidden="true" class="spinner-border spinner-border-sm">
                    </span>&nbsp;&nbsp;Downloading...
                  </button> -->

                </div>

                <div class="table-responsive mb-0">
                  <b-table
                    sort-icon-left
                    :items="sitesGroup ? siteDataItemsTable : siteDataByDateTable "
                    :fields="sitesGroup ? siteDataFields : siteDataByDateFields"
                    responsive
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :no-border-collapse="false"
                  >
                  <template v-slot:cell(no.)="data">
                    <b class="field">{{ (currentPage - 1) * perPage + data.index + 1 }}</b>
                  </template>

                  <template v-slot:cell(domain)="data">
                    <b class="field"> {{ data.item.domain }}</b>
                  </template>

                  <template v-slot:cell(pageViews)="data">
                    <b class="field" v-if="data.item.pageViews && data.item.withoutAdblockPageViews"> {{ data.item.pageViews.toLocaleString('de-DE', { maximumFractionDigits: 2 }) }}</b>
                    <b v-else class="field" > - </b>
                  </template>

                    <template v-slot:cell(adblockRate)="data">
                    <b class="field" v-if="data.item.adblockRate"> {{ data.item.adblockRate >= 100 ? 100 : data.item.adblockRate }}%</b>
                    <b v-else class="field" > - </b>
                  </template>

                  <template v-slot:cell(impressions)="data">
                    <b class="field">{{ data.item.impressions.toLocaleString('de-DE') }}</b>
                  </template>

                  <template v-slot:cell(cpm)="data">
                    <b class="field">{{data.item.cpm ? currency + data.item.cpm.toLocaleString('de-DE', { maximumFractionDigits: 2 }) : currency + '0,00' }}</b>
                  </template>

                  <template v-slot:cell(grossRevenue)="data">
                    <b class="field">{{ data.item.grossRevenue ? currency + data.item.grossRevenue.toLocaleString('de-DE', { maximumFractionDigits: 2 }) : currency + '0,00' }}</b>
                  </template>
                  <template v-slot:cell(netRevenue)="data">
                    <b class="field">{{ data.item.netRevenue ? currency + data.item.netRevenue.toLocaleString('de-DE', { maximumFractionDigits: 2 }) : currency + '0,00' }}</b>
                  </template>
                  <template v-slot:cell(platform)="data">
                    <b class="field">Desktop</b>
                  </template>
                  </b-table>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Embedded quicksight dashboard -->
      <div v-if="seeAs !== 'user' && seeAs !== 'finance'" class="row">
        <div class="col-xl-12">
          <div class="card-box pb-1">
            <h4 class="header-title mb-3">Information</h4>
            <div v-if="!showEmbeddedContainer">
              <button v-if="!embedLoading" type="button" class="btn btn-primary" @click="toggleEmbeddedContainer">
                <span aria-hidden="true">Load metrics</span>
              </button>
              <button v-if="embedLoading" type="button" disabled="disabled" class="btn ml-1 btn-primary disabled download-btn">
                <span aria-hidden="true" class="spinner-border spinner-border-sm">
                </span>&nbsp;&nbsp;Loading...
              </button>
            </div>
            <div v-show="showEmbeddedContainer" style="height: 900px;">
              <div ref="embeddingContainer" center></div>
            </div>
          </div>
        </div>
      </div>
  </Layout>
</template>


<style lang="scss">

  .see-as-label {

  }

  .mode-selector {
    text-align: right;
  }

  .revenue-ribbon {
    position: absolute!important;
    top: 5px!important;
  }

  .home-page {
    .site-select {
      height: 35px !important;
    }
    .home-date-picker {
      width: 240px!important;
    }
    .mx-shortcuts {
      font-weight: bold!important;
      text-decoration: underline;
    }
    .download-btn {
      height: 32px;
      line-height: 18px;
    }

    .multiselect__content-wrapper {
      width: 100%!important;

    }
    .multiselect__tags {
      max-width: 400px!important;
      min-width: 300px!important;
      height: 37px;
      overflow: scroll !important;
      margin-top: 1.5px;
    }
    ::-webkit-scrollbar
    {
        width:0px;
        height:0px;
    }
    .flex-form{
    display: flex;
    flex-direction: row;
    align-items: flex-start !important;
    }

  }

  .field{
    font-weight: 300;
  }
  .widget-card-unit{
    border-radius: 8px;
    // box-shadow: 1px 2px 6px#dee2e6;
  }

  .static-domain{
    font-size: 1.1rem;
    display: inline-block;
    height: 3rem;
    line-height: 3rem;

  }
  .category{
    font-size: 0.9rem;
    display: inline-block;
    height: 3rem;
    line-height: 3rem;

  }
  .pie-chart{
    box-sizing: border-box;
    border: 3px white solid;
    border-radius: 10px;
    padding-bottom: 20px;
    p{
      font-size: 1rem;
    }
  }

  .apexcharts-slices{
    // transform: scale(1.05) translateY(-5px);
  }

  .apexcharts-legend{
    // transform: translateY(15px);
  }

  .bar-chart{
    box-sizing: border-box;
    border-radius: 10px;
    margin: 2px;
    p{
      font-size: 1rem;
      position: relative;
      bottom: 0.7rem;
      padding:0 20px;
    }
  }

  .bg-light{
    background-color: rgba($color: #f1f5f767, $alpha: 0.5) !important;
  }

  .urgent-alert{
    z-index: 100;
    position: fixed;
    bottom: 1rem;
    right: 4rem;
    width: 40%;
    p{
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }

  .date-conflict{
    line-height: 2.2rem;
    font-size: 1.3rem;
    color: black;
    margin-top:15vh;
  }

  .mdi-alert-circle{
    font-size: 32px;
    line-height: 32px;
    color: #f1556c;
    &:hover {
      color: red;
    }
  }

  .calculator{
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    width:400px;
    z-index: 100;
    padding-left: 10px;
    padding-right: 10px;
    background: #ffd26f;
    .currency-unit,
    .rate-unit{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 20px;
      input {
        background-color: #ffd26f;
        color: black;
      }
      img{
        width: 40px;
        border-radius: 2px;
        box-shadow: 5px 2px 5px rgba($color: gray, $alpha: 0.3);
        margin-right: 10px;
      }

    }

    .currency-unit input{
      border:none;
      border-bottom: 1px solid black;
      border-radius: 0;
      text-align:right;
    }
    .rate-unit input {
      width: 80px;
      border: 1px solid black;
    }


  }

  @media (max-width: 768px){
    .static-domain {
    display: none;
    }
    .site-metrics-download{
      display: none;
    }
 }


</style>
